import {
  AreasListTypes,
  DepartmentsByAreaTypes,
  SpecialistDetailTypes,
  SpecialistRatingParamsTypes,
  SpecialistsByDepartmentTypes,
  SpecialistDetailData,
  SpecialistDetailDataParams,
} from './type';

import axiosInstance from 'services/common/instance';

const getAreasListService = async (): Promise<AreasListTypes[]> => {
  const res = await axiosInstance.get('khcn/areas');
  return res.data.data;
};

export const getDepartmentsByAreaService = async (
  params: number,
): Promise<DepartmentsByAreaTypes[]> => {
  const res = await axiosInstance.get(`khcn/departments/area/${params}`);
  return res.data.data;
};

export const getSpecialistsByDepartmentService = async (
  params: number,
): Promise<SpecialistsByDepartmentTypes[]> => {
  const res = await axiosInstance.get(`khcn/specialists/department/${params}`);
  return res.data.data;
};

export const getSpecialistsDetailService = async (
  params: number,
): Promise<SpecialistsByDepartmentTypes> => {
  const res = await axiosInstance.get(`khcn/specialists/${params}`);
  return res.data.data;
};

export const getSpecialistDetailService = async (
  params: number,
): Promise<SpecialistDetailTypes[]> => {
  const res = await axiosInstance.get(`khcn/specialists/${params}`);
  return res.data.data;
};

export const postSpecialistRatingService = async (
  params: SpecialistRatingParamsTypes,
) => {
  const body = {
    star: params.star,
    grecaptcha_token: params.grecaptcha_token,
  };
  await axiosInstance.post(`khcn/specialists/${params.id}/rating`,
    body);
};

export const getSpecialistListService = async (
  params: SpecialistDetailDataParams,
): Promise<PaginationData<SpecialistDetailData[]>> => {
  const res = await axiosInstance.get('khcn/specialists', { params });
  return res.data;
};

export default getAreasListService;
